import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'siaTranslate',
  standalone: true,
})
export class SiaTranslatePipe implements PipeTransform {
  #boundary = '\u200B';
  #processed = '\u200C';

  transform(txt: string | undefined | null): string {
    if (!txt) return '';

    // Se è già marcato "processato", non aggiungere boundary
    if (txt.includes(this.#processed)) {
      return txt;
    }

    // Se contiene già boundary, evita di raddoppiarli
    if (txt.includes(this.#boundary)) {
      return txt;
    }

    return this.#boundary + txt + this.#boundary;
  }
}
